
import {defineComponent, PropType} from "vue";
import {CodeDescriptionRestDto,} from "@/api/pharma-cpc-product-mgmt/models";
import SelectCategories from "@/components/layouts/catalog/SelectCategories.vue";
import {EnumClassNameCpcEnum} from "@/models/enum/EnumClassNameCpcEnum";
import {
  MultilingualTextFieldRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/MultilingualTextFieldRestDtoModel";
import {StatusEnum} from "@/api/enums/status-enum";
import InputTextEditor from "@/components/UI/InputTextEditor.vue";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";
import {
  CustomerProductWithImageDetailRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CustomerProductWithImageDetailRestDtoModel";
import {FormMixin} from "@/components/base/FormMixin";
import {ProductRestService} from "@/services/rest/cpc-product/ProductRestService";
import {CustomerContext} from "@/context/CustomerContext";
import { cloneDeep } from 'lodash';

export default defineComponent({
  name: "CustomerProductProduct",
  mixins: [FormMixin],
  components: {InputTextEditor, SelectCategories},
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Object as PropType<CustomerProductWithImageDetailRestDtoModel>,
      required: true
    },
    errors: {
      type: Object,
    },
    mode: {
      type: String,
      required: true,
      validate(value: string) {
        return value === PageDetailModeEnum.NEW || value === PageDetailModeEnum.EDIT;
      }
    }
  },
  data: () => ({
    usageTypeOptions: [] as CodeDescriptionRestDto[],
    trademarkOptions: [] as CodeDescriptionRestDto[],
    localProduct: CustomerProductWithImageDetailRestDtoModel.createWithDefaults(),
  }),
  mounted() {
    this.initialize();
  },
  watch: {
    modelValue: {
      handler(_newValue: CustomerProductWithImageDetailRestDtoModel) {
        this.reloadContent();
      },
      immediate: true,
    },
  },
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    },
    DpModuleEnum() {
      return DpModuleEnum;
    },
    statusOptions(): CodeDescriptionRestDto[] {
      return [
        {code: StatusEnum.PUBLISHED, description: this.$t('published')},
        {code: StatusEnum.NOT_PUBLISHED, description: this.$t('notPublished')},
      ] as CodeDescriptionRestDto[];
    },
  },
  methods: {
    async doInitialize(): Promise<void> {
      this.trademarkOptions = await ProductRestService.getInstance().getAllTrademarks(CustomerContext.getCustomerCode());
      this.usageTypeOptions = await EnumRestService.getInstance().getCpcEnumValuesByClassname(EnumClassNameCpcEnum.PRODUCT_USAGE_TYPE);
    },
    async doReload(): Promise<void> {
      this.localProduct = {...this.modelValue};
    },
    addCategory(categoryCode: string): void {
      if (!this.localProduct.product.category_codes) {
        this.localProduct.product.category_codes = [];
      }
      this.localProduct.product.category_codes.push(categoryCode);
      this.emitChangedModel();
    },
    removeCategory(categoryCode: string): void {
      if (!this.localProduct.product.category_codes) {
        this.localProduct.product.category_codes = [];
      }
      this.localProduct.product.category_codes = this.localProduct.product.category_codes.filter((code: string) => code !== categoryCode);
      this.emitChangedModel();
    },
    updateEditorContent(content: string): void {
      if (content === '') {
        this.localProduct.product.description = null;
      } else {
        if (!this.localProduct.product.description) {
          this.localProduct.product.description = MultilingualTextFieldRestDtoModel.createWithDefaults();
        }
        this.localProduct.product.description.nl = content;
      }
      this.emitChangedModel();
    },
    emitChangedModel(): void {
      this.$emit('update:modelValue', cloneDeep(this.localProduct));
    },
  },
});
